import React from 'react';
import HeaderBread from '../../layout/Header_Bread'
import { Dropdown, Label, Divider, Form, Header, Message, Button, Icon, Modal, Image, Loader, Dimmer } from 'semantic-ui-react'
import { Grid, Container } from 'semantic-ui-react'
import { Step1a } from './Step1a'
import { Step2a } from './Step2a'
import { Step3a } from './Step3a'
import { Consumer, MyContext, Provider } from '../../../../context/Context'
import axios from '../../../../services/AxiosOrders'
import { Redirect, Route, Switch } from 'react-router-dom'
// import UploadImage from '../../filepod/UploadImage'
import { MyStore } from '../../../../services/Store'
import FileLogTable from '../../filepod/FileLogTable'

import Directions from './Directions'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import moment from 'moment'

// const uuid = require('uuid/v4');
// const uuidv1 = require('uuid/v1');
import    { v4 as uuid }  from 'uuid';
import       { v1 as uuid1 }  from 'uuid';



// Register the plugins
registerPlugin(FilePondPluginImagePreview, FilePondPluginImageExifOrientation);

// const filesGroupId = uuid()
let projectStarted = false
class MasterForm extends React.Component {
  constructor(props) {
    super(props)
    this.goBack = this.goBack.bind(this);
    this.filesGroupId = uuid()
    this.state = {
      open: false,
      name:'',
      mrn:'',
      gender:'',
      dob:'',
      age:'',

      // addUser:'',
      addingUserToProject:'',

      // uploadValue:'',
      cardId: '',
      currentStep: 1,
      service: '',

      text: '',
      title: '',
      description: '',
      members: {},


      email: '',
      payment: '',
      price: '',
      voucher: '',
      imgUrl: '',
      heading: '',

      errors: {},
      toDashboard: false,
      status: false,
      metadataFile: this.metadataFile,
      files: "",
      logs: "",
      projectStarted: false,
      projectCompleted: false,
      draft: false,
      filesGroupId: this.filesGroupId,
      oid:'',
    }
    // this.filesGroupId = ''
    // this.cardId = ''
    this.addingUserToProject = ''
    this.projectNew = true
    this.files = []
    this.logs = []
    this.metadataFile = {
      name: '',
      size: '',
      contentType: '',
      fullPath: '',
      downloadURL: '',
      key: '',
    }

    this.log = {
      action: '',
      timestamp: null
    }
    this.uploadStatus = false
    this.storageRef = MyStore.storage().ref();

    this.databaseRef = MyStore.database().ref();
    this.currentGroup = ''
    this.groupRef = MyStore.database().ref().child("groups")
    this.newCard = {
      cardId: '',
      service: '',
      heading: '',
      imgUrl: '',
      text: '',
      title: '',
      description: '',
      voucher: '',
      email: '',
      userId: '',
      date: '',
      // metadataFile:'',
      files: '',
      logs: '',
      status: '',
      projectStarted: '',
      projectCompleted: '',
      draft: '',
      filesGroupId: this.filesGroupId,
      logsGroupId: this.filesGroupId,
    };
    this.localId = ''
    this.token = ''
    this.boolDraft = this.boolDraft.bind(this);
     
    
    // this.handleClick = this.handleClick.bind(this);
    this.clickModal = this.clickModal.bind(this)
    // this.cookiesModal=this.cookiesModal.bind(this)
    this.modalFunction=this.modalFunction.bind(this)

  }


  handleClose = () => this.setState({ open: false })
  handleOpen = () => this.setState({ open: true })


  onChange = e => {
    // console.log('---------------- onchange --------- line 137')
    // console.log(e.target)
    // console.log(e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  handleTitle = ()=>{
    let mrn = ''
    if (this.state.mrn) {
      mrn = 'MRN#' + ' ' +  (this.state.mrn) 
    }
    let titleMrn =   (this.state.age)+' ' + (this.state.gender)  + ' ' + (this.state.name) +' '+ (mrn) 

    this.setState({title: titleMrn})

}

  createCardId = async () => {
    // const { imgUrl, heading, text, title, description, payment, email, voucher , service, cardId, status, metadataFile, logs, files, projectStarted, projectCompleted, draft} = this.state;
    const { imgUrl, heading, text, title, description, email, voucher, service, status, name, mrn, gender, cardId } = this.state;




    const localId = localStorage.getItem('userId')
    const token = localStorage.getItem('token')


    // console.log(newCard)


    // let resp = await axios.post(`/${localId}/cards.json?auth=${token}`, this.newCard);

    // let resp = await axios.post(`/groups/${this.props.oid}/cards.json?auth=${token}`, this.newCard);

    // this.cardId = resp.data.name
    // let tempCardId = ''

    let resp = await axios.post(`/groups/${this.props.oid}/cards.json?auth=${token}`, this.newCard);

    this.cardId = resp.data.name
    this.setState({cardId: resp.data.name});
    // let tempCardId = ''
    // resp.then( result => {
    //   this.cardId = result.data.name
    //   console.log(this.cardId )
    //   console.log(result)
    //   console.log(result.data.name)
    //     this.setState({cardId: result});
    //     // tempCardId = result
    // }, function(error) {
    //   console.log(error)
    // })



    // resp.then((data) => {  
    //     console.log('Data from processDataAsycn() with async( When promise gets resolved ): ' + data);
    //     this.cardId = data  

    //   }).catch((error) => {  
    //     console.log('Error from processDataAsycn() with async( When promise gets rejected ): ' + error);  
    //   })
  
    // console.log('inside create card id')
    // console.log(this.metadataFile)
    // this.setState({ cardId: resp.data.name })

    // this.metadataFile['key'] = this.cardId
    this.metadataFile['key'] = this.cardId

    // this.files.push(this.metadataFile)
    // this.logs.push(this.log) 



    // this.state.files.push(this.metadataFile)
    // this.state.logs.push(this.log)




    this.newCard = {
      cardId: this.cardId,
      service,
      heading,
      imgUrl,
      text,
      title,
      description,
      voucher,
      email,
      userId: localId,
      date: new Date(),
      // metadataFile: this.metadataFile,
      files: this.files,
      logs: this.logs,
      status,
      projectStarted: true,
      projectCompleted: false,
      draft: true,
      filesGroupId: this.filesGroupId,
      logsGroupId: this.filesGroupId,
    };

    // resp = await axios.put(`${localId}/cards/${this.cardId}.json?&auth=${token}`, this.newCard);
    resp =  await axios.put(`/groups/${this.props.oid}/cards/${this.cardId}.json?auth=${token}`, this.newCard);
     
    // resp.then( result => {
    //     this.setState({cardId: result});
    //     tempCardId = result
    // }, function(error) {
    //   console.log(error)
    // });
    if (this.cardId ){
      return  this.cardId
    }
    else
    return
  }

  onSubmit = async (dispatch, auth, e) => {
    e.preventDefault();
    this.handleTitle()

    // const { imgUrl, heading, text, title, description, payment, email, voucher , service, cardId, status, projectStarted, projectCompleted,draft} = this.state;


    const { imgUrl, heading, text, title, description, email, service, status, projectStarted, projectCompleted, draft, name, mrn, gender, dob, age } = this.state;

    if (name === '') {
      this.setState({ errors: { name: 'name is required' } });
      return;
    }

    if (mrn === '') {
      this.setState({ errors: { mrn: 'MRN is required' } });
      return;
    }

    // if (gender === '') {
    //   this.setState({ errors: { gender: 'gender is required' } });
    //   return;
    // }

    // if (dob === '') {
    //   this.setState({ errors: { dob: 'date of birth is required' } });
    //   return;
    // }


    // console.log('this.state.cardid----------------------------')
    // console.log(this.state.cardId)
    let resp = ''
    if (this.cardId === undefined) {
      // resp = await axios.post(`/${auth.localId}/cards.json?auth=${auth.token}`, this.newCard);
      resp = await axios.post(`/groups/${this.props.oid}/cards.json?auth=${auth.token}`, this.newCard);
      this.cardId = resp.data.name
      
      
      this.newCard = {
        cardId: resp.data.name,
        service,
        heading,
        imgUrl,
        text,
        title,
        description,
        // voucher,
        email,
        userId: auth.localId,
        date: new Date(),
        // metadataFile: this.metadataFile,
        files: this.files,
        logs: this.logs,
        status,
        projectStarted,
        projectCompleted,
        draft,
        filesGroupId: this.filesGroupId,
        logsGroupId: this.filesGroupId,

        name,
        mrn, 
        dob,
        gender,
        age,


      };


      // resp = await axios.put(`${auth.localId}/cards/${this.cardId}.json?&auth=${auth.token}`, this.newCard);
      resp = await axios.put(`/groups/${this.props.oid}/cards/${this.cardId}.json?auth=${auth.token}`, this.newCard);
    }
    else {
      this.newCard = {
        cardId: this.cardId,
        service,
        heading,
        imgUrl,
        text,
        title,
        description,
        // voucher,
        email,
        userId: auth.localId,
        date: new Date(),
        // metadataFile: this.metadataFile,
        files: this.files,
        logs: this.logs,
        status,
        projectStarted: true,
        projectCompleted: false,
        draft: true,
        filesGroupId: this.filesGroupId,
        logsGroupId: this.filesGroupId,


        name,
        mrn, 
        dob,
        gender,
        age,
      };

      // resp = await axios.put(`${auth.localId}/cards/${this.cardId}.json?&auth=${auth.token}`, this.newCard);
      
      resp = await axios.put(`/groups/${this.props.oid}/cards/${this.cardId}.json?auth=${auth.token}`, this.newCard);
    }




    dispatch({ type: 'ADD_CARD', payload: { ...this.newCard, id: this.cardId } });

    this.setState({ errors: {}, toDashboard: true });
    this.projectNew = true
  };




  componentDidMount() {

    

    this.localId = localStorage.getItem('userId');
    this.token = localStorage.getItem('token');
    // console.log('-----------masterform.js line 346 this.props------ ')
    // console.log(this.props)
    // console.log('---------- this.props.oid --------')
    // console.log(this.props.oid)
    this.state.oid = this.props.oid
    this.setState({
      oid: this.props.oid
    })

    // document.addEventListener('mousedown', this.handleClick, false)


  }


  closeConfigShow = (closeOnEscape, closeOnDimmerClick) => () => {
    this.setState({ closeOnEscape, closeOnDimmerClick, open: true })
  }



  componentWillUnmount(){
    // clearInterval(this.interval);
    // clearTimeout(this.timeout)
    // document.removeEventListener('mousedown', this.handleClose, false)
    clearTimeout(this.timeout);
  }


  getCurrentGroup=()=>{
    // const recipeKey = '-LwLujWwcsr6szQxZYer';
    
    const recipeKey = this.props.oid
    let cg = []
    MyStore.database().ref().child(`/groups/${this.props.oid}`).on('value', snap => {
      // let groups = []
      // console.log(snap.val())
      // cg = snap.val()
      this.currentGroup = snap.val()
                  let myArr = []
                  // console.log('----------- function 02 -------------')
                  for (const key in snap.val()) {
                      myArr.push(Object.assign({}, snap.val()[key]));
                  }
                  if (snap.val() != null) {
                      // users = myArr
                      cg = myArr
                      // setState({myArr})
                  }
                  // else {
                  //   this.setState({
                  //     groups: []
                  //   })    
                  // }

              });

  }

  handleClick=(e)=>{
    // e.preventDefault();

    if(e){
      // console.log('iside if')
      // this.handleClose()
      return(
        <Modal onClick={this.handleClose}>

        </Modal>

      )
    }
    else{
      // console.log('outside if')
      return
    }
    // this.handleClickOutside()
  }




  handleChange = event => {
    const { name, value } = event.target
    this.setState({
      [name]: value
    })
  }

  DropdownExampleSelection = (onChange, value) => (
    <Dropdown
      placeholder='Select a  Service'
      fluid
      selection
      //   defaultValue={serviceOptions[0].text}
      options={serviceOptions}
      onChange={(e, { value }) => this.handleMenuChange(value)} />)



  // buttonSelection = (onChange, value) => (
  //     <Button 
  //       placeholder='Select a  Service'
  //       fluid
  //       selection
  //     //   defaultValue={serviceOptions[0].text}
  //       options={buttonOptions}
  //       onChange={(e, { value }) => this.handleMenuChange(value)} />)


  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  handleMenuChange = value => {
    //  alert(value)
    this.service = value
    this.setState({
      service: value
    })
    // console.log(serviceOptions[0].text)
  }

  _next = () => {
    let currentStep = this.state.currentStep
    currentStep = currentStep >= 2 ? 3 : currentStep + 1
    this.setState({
      currentStep: currentStep
    })
  }

  _prev = () => {
    let currentStep = this.state.currentStep
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({
      currentStep: currentStep
    })
  }

  /*
  * the functions for our button
  */
  previousButton() {
    let currentStep = this.state.currentStep;
    if (currentStep !== 1) {
      return (
      //   <Button fluid size='big'  style={{width:"27%", float:"left", marginRight:"2vw"}}
      //     type="button" onClick={this._prev}   >
      //     Previous
      // </Button>

      <Button icon labelPosition='left'    type="button" onClick={this._prev}  
         style={{width:"15%", float:"left", marginLeft:"2vw", height:"55%"}}>
      
      <Icon  size='large'  name='chevron left' />
      {/* Previous */}
    </Button>
      )
    }
    return null;
  }
  

  nextButton() {

    let currentStep = this.state.currentStep;
    if (currentStep < 3) {
      return (
      //   <Button  fluid color='teal' size='big'  style={{width:"27%", float: "right"}}
      //     type="button" onClick={this._next}>
      //     Next
      // </Button>

      <Button icon labelPosition='right'    type="button" onClick={this._next}  
         style={{width:"15%", float:"right", marginRight:"2vw", height:"55%"}}>
      
      <Icon  size='large'  name='chevron right' />
      {/* Previous */}
    </Button>

    
      )
    }
    return null;
  }


  mouseHoverEnter() {
    // var linkStyle;
    //   linkStyle = {backgroundColor: 'red'}
    return (
      <Message warning icon='user md'
        header='Healthcare Brief'
        content='Create a Draft Project'></Message>)

  }


  mouseHoverLeave() {
    var linkStyle;
    linkStyle = { backgroundColor: 'blue' }

  }



  handleInit() {
    console.log("FilePond instance has initialised", this.pond);
  }
 





  NestedModal = () => {
    const { open, closeOnEscape, closeOnDimmerClick } = this.state
    return (
      <Modal
      // visible={this.state.open.toString()}
        // disabled={this.state.open}
        // open={this.state.open}
        // onOpen={this.handleOpen}

        // onClick={this.handleOpen}
        // open={this.state.open}
        // basic
        // disabled={this.state.open}
        // positive

        // closeOnEscape={closeOnEscape}
        // closeOnDimmerClick={closeOnDimmerClick}

        // onClose={this.handleClose}
        // onClick={this.closeConfigShow(true, true)}
        size='mini'
        trigger={
          <Button
            positive
            icon='checkmark'
            labelPosition='right'
            content="Create Draft"
            // onClick={bind(this.boolDraft)}
            // onClose={this.handleClose}
            onClick={(e) => this.boolDraft(e)}
          // this.handleClick.bind(this);
          />

          // <Button primary icon>
          //   Proceed <Icon name='right chevron' />
          // </Button>
        }
      >



        {/* if (data === undefined || data.length === 0) {
    return <Spinner />; */}


        <Modal.Header style={{ textAlign: "center" }}>Generating New Project Contaner</Modal.Header>
        <Modal.Content >
          <Dimmer active>
            <Loader indeterminate size="large">Generating New Project Contaner</Loader>
          </Dimmer>
          {/* <Spinner/> */}
          {/* <p>That's everything!</p> */}
        </Modal.Content >
        <Modal.Actions>
          
          {/* <React.Fragment onOpen={
            setTimeout(() => {
              this.handleClose()
              console.log('Hello, World!')
            }, 10000)
        }>

        </React.Fragment> */}

          {/* <Button icon='check' content='All Done' onClick={this.handleClose} /> */}
        </Modal.Actions>
      </Modal>
    )
  }


  // DraftCreation() {
  //   // const isLoggedIn = props.isLoggedIn;
  //   if (this.state.projectStarted) {
  //     return <div />;
  //   }
  //   return <div />;
  // }

  // componefntDidMount() {
  //   this.interval = setInterval(() => {
  //     this.onToggle();
  //   }, 5000);
  // }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  goBack(){
    // this.props.history.goBack();
    this.props.props.history.goBack();
}


  DraftCreation() {

    if (this.state.projectStarted) {
      const recipeKey = this.props.oid
        this.timeout = setTimeout(() => {

        //   const inivitedUser = {
        //     avatar: tempInvite.avatar,
        //     uid: tempInvite.uid,
        //     username: tempInvite.username,
        //     displayName:  tempInvite.displayName,
        //     role: tempInvite.role,
        //     // role: roleKeys[key].role,
        //     timestamp: Date.now(),
        //     momentTimestamp: moment().format('LLL')
        // }

        // let addUser =''
 
        // const recipeKey = '-LwLujWwcsr6szQxZYer';
   
        MyStore.auth().onAuthStateChanged((currentUser) => {
          if (currentUser) {

            // console.log(currentUser.uid)

            let addingUserToProject={}
            let tempCardId = ''
          
            this.databaseRef.child(`/groups/${this.props.oid}/members/${currentUser.uid}`).on('value', snap => {
                // console.log(snap.val())
                // addUser = snap.val()



           addingUserToProject = {
                avatar:  snap.val().avatar,
                uid:  snap.val().uid,
                username:  snap.val().username,
                displayName:   snap.val().displayName,
                role:  snap.val().role,
                // role: roleKeys[key].role,
                timestamp: Date.now(),
                momentTimestamp: moment().format('LLL')
            }
            
          //  const temp =  this.createCardId()
          //  console.log(temp)

            this.createCardId().then((data) => {  
              // console.log('Data from processDataAsycn() with async( When promise gets resolved ): ' + data);
              this.cardId = data  

              const currentMbrProjects = {
                id: this.cardId, 
                isMember: true,
                logId: this.filesGroupId
            }
            // console.log('line --- 758')
            // console.log(currentMbrProjects)
            // console.log(addingUserToProject)
    
              this.databaseRef.child(`/groups/${this.props.oid}`).child('mbrprojects').child(currentUser.uid).child('cards').child(this.cardId).set(currentMbrProjects)
              this.databaseRef.child(`/groups/${this.props.oid}`).child('mbrcards').child(filelogid).child(addingUserToProject.uid).set(addingUserToProject)
              


            }).catch((error) => {  
              console.log('  ' + error);  
            })
     
            //  tempCardId =   this.createCardId()
            //  tempCardId.then(function(result) {
            //           this.cardId = result
            //           console.log(result)
            //       }, function(err) {
            //       console.log(err)
            //       }.bind(this))


             
          //  console.log(tempCardId)


                // this.setState({addUser: snap.val()})
              

              })



    // const localId = localStorage.getItem('userId')
    // const token = localStorage.getItem('token')

 

    // let resp =  axios.post(`/groups/${this.props.oid}/cards.json?auth=${token}`, this.newCard);

 
    // resp.then( result => {
    //   this.cardId = result.data.name
    //   console.log(this.cardId )
    //   console.log(result)
    //   console.log(result.data.name)
      
    // }, function(error) {
    //   console.log(error)
    // })

    
    // console.log('inside create card id')
    // console.log(this.metadataFile)
    // this.setState({ cardId: resp.data.name })

    // this.metadataFile['key'] = this.cardId
    // this.metadataFile['key'] = this.cardId

    // // this.files.push(this.metadataFile)
    // // this.logs.push(this.log) 



    // // this.state.files.push(this.metadataFile)
    // // this.state.logs.push(this.log)




    // this.newCard = {
    //   cardId: this.cardId,
    //   // service,
    //   // heading,
    //   // imgUrl,
    //   // text,
    //   // title,
    //   // description,
    //   // voucher,
    //   // email,
    //   userId: localId,
    //   date: new Date(),
    //   // metadataFile: this.metadataFile,
    //   files: this.files,
    //   logs: this.logs,
    //   status: false,
    //   projectStarted: true,
    //   projectCompleted: false,
    //   draft: true,
    //   filesGroupId: this.filesGroupId,
    //   logsGroupId: this.filesGroupId,
    // };

    // // resp = await axios.put(`${localId}/cards/${this.cardId}.json?&auth=${token}`, this.newCard);
    // resp =  axios.put(`/groups/${this.props.oid}/cards/${tempCardId}.json?auth=${token}`, this.newCard);
     
            
              // const filelogid = '6d3a17f7-3ebc-4939-abf6-447cffebaafe'

              const filelogid = this.filesGroupId
 
  
    
   
  

  
            
            }})

          // console.log(addUser)

          this.handleMenuChange(serviceOptions[0].text)
          this.handleClose()
          
          // console.log('DraftCreation DraftCreation !')   
        }, 3000);
   
        
    }

  }

  boolDraft() {
    // this.setState({
    //   projectStarted: true
    // });
    this.state.projectStarted = true

    // this.setState({ open: true })
    this.DraftCreation()
  
    // this.handleClose()
  }


  modalFunction() {
    return (
      <React.Fragment>
        <Modal
          dimmer="blurring"
          open={this.state.open}
          // onClick={this.handleOpen}
          onOpen={this.handleOpen}
          onClose={this.handleClose}
          size="small"
           onClick={this.closeConfigShow(true, true)}       //closing on exit
              // visible={this.state.open.toString()}
        // disabled={this.state.open}
        // positive
        >

          <Modal.Header style={{ textAlign: "justfied" }}>Create A Draft Project? </Modal.Header>
          <Modal.Content image>

            <Modal.Description>
              {/* <p>We have more to share with you. Follow us along to modal 2</p> */}

              <Directions></Directions>
            </Modal.Description>

            {/* <div className='image'>
              <Icon name='wpforms' />
            </div> */}
            {/* <div className='image'  style={{ align : "right", padding: "1em"}}>
      <Image 
              wrapped
              size='medium'
              // src='https://react.semantic-ui.com/images/avatar/large/rachel.png'
              src={rad_icons}
            />
      </div> */}
          </Modal.Content>
          <Modal.Actions>
            {/* <NestedModal /> */}
            {this.NestedModal()}
            <Button color='black' onClick={this.handleClose}>
              Nope
      </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }


  // boolDraft() {
  //   // this.setState({
  //   //   projectStarted: true
  //   // });
  //   this.state.projectStarted = true

  //   // this.setState({ open: true })
  //   this.DraftCreation()
  // }


  

  projectStatus(){
    if (this.state.projectStarted){
      return(
        <Button color="teal" style={{
          // float:"justified"
          // marginLeft:"30px", marginRight:"10px",
          margin:'auto',
            width: "11vw",  height:"7vw", minWidth: "200px", minHeight:"50px"
          }} animated='fade' >
        <Button.Content visible>Project Status: Created</Button.Content>
        <Button.Content hidden>Checkout to save project </Button.Content>
      </Button>
      ) 
    }
    else{
      return(
        <React.Fragment>

                {this.clickModal()}
                {/* {this.modalFunction()} */}
        {/* <Button color="red" style={{float:"justified"}} animated='fade'  >
        <Button.Content visible>Project Status: Not Created</Button.Content>
        <Button.Content hidden>Create a New Draft Project?</Button.Content> */}

      {/* </Button> */}
        </React.Fragment>

      )
    }
  }




  clickModal(){
    // e.preventDefault();
    return(
      <React.Fragment>
       
      
      <Modal
          dimmer="blurring"
          open={this.state.open}
 
          onOpen={this.handleOpen}
          onClose={this.handleClose}
          size="small"
 
        trigger={
  

          
          <Button color="red"  style={{
         
                float:"left",
            // margin: "justfied",
            // width: "18vw",
            // border: "3px",
            // padding: "10px",
            // maxMin: "100px",
            // marginLeft:"30px", marginRight:"10px",
            margin:'auto',
            // marginLeft:"20px", marginRight:"10px",
              width: "11vw",  height:"7vw", minWidth: "200px", minHeight:"50px"
              
            // marginRight:"350px",
   
          
          }} animated='fade'   >
          <Button.Content color="red" visible>Project Status: Not Created</Button.Content>
          <Button.Content color="red" hidden>Create a New Draft Project?</Button.Content>
          </Button>
         }>

          <Modal.Header style={{ textAlign: "justified" }}>Create A Draft Project? </Modal.Header>
          <Modal.Content image>

            <Modal.Description>
              <Directions></Directions>
            </Modal.Description>

            {/* <div className='image'>
              <Icon name='wpforms' />
            </div> */}
 
          </Modal.Content>
          <Modal.Actions>

            {this.NestedModal()}
            <Button color='black' onClick={this.handleClose}>
              Nope
      </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
    
    // this.modalFunction()
  }
  // onClick={(e) => this.modalFunction(e)}

     createNewProject = ()=>(


        <Switch>
        <Route  to="/cadre/:id/dashboard"  />
        {/* <Redirect from="/dashboard:id" to="/dashboard/:id" /> */}
      </Switch>
    )
  
  render() {
    const { cardId } = this.state
    // const { imgUrl, heading, text, title, description, email, service, status, projectStarted, projectCompleted, draft, name, mrn, gender, dob, age } = this.state;

    const path = `/cadre`+ this.props.oid + 'dashboard'
    // const path = `/projectlist/`+ this.props.oid
    // const { activeItem } = this.state
    // const { open } = this.state
    // const { imgUrl, heading, text, title, description, members, payment, price, voucher, errors } = this.state;
    if (this.state.toDashboard) {
      // return <Redirect to="/cardlist" />;
      // this.props.props.history.push(path);
      // this.props.props.history.push(path);
      this.goBack()
       // this.createNewProject()
      // return <Redirect to='/'/>;
     
    }
    return (
      <React.Fragment>


        <Consumer>
          {value => {
            const { dispatch, auth } = value;
            return (

              <React.Fragment>
                {/* <ModalExampleCloseIcon></ModalExampleCloseIcon> */}
                {/* <h1>React Wizard Form 🧙‍♂️</h1> */}
                {/* {this.handleClick()} */}
                <div   >
                {this.modalFunction()}
                </div>
              
                {/* <HeaderBread></HeaderBread> */}
                
                <Container textAlign='justified' style={{marginTop: '-60px'}}>
                  <Label color='teal' ribbon='right' > Draft </Label>
                  <Divider  />
              


            

                  <Grid>
                    <Grid.Column   width={11}>

                      {/* {this.DropdownExampleSelection()}<br></br> */}
                      {/* {this.buttonSelection()}<br></br> */}

                      <div  >

                        {/* onMouseEnter={this.someHandler}
    onMouseLeave={this.someOtherHandler} */}


                        <Grid >


                        {this.projectStatus()}

                      

                        <Button   inverted color='blue'    
                  style={{
                      margin:'auto',
                        width: "11vw",  height:"7vw", minWidth: "200px", minHeight:"50px"
                    }} 
                    // onClick={(e) => this.handleMenuChange(serviceOptions[0].text)} 
                    
                    >
                        Healthcare Brief
                        </Button>

                        {/* <Button   inverted color='blue'   
                  style={{
                    margin:"auto",  marginLeft:"30px", marginRight:"10px", width: "10vw",  height:"6vw", minWidth: "200px", minHeight:"50px"
                    }} onClick={(e) => this.handleMenuChange(serviceOptions[0].text)} >
                        Healthcare Brief
                        </Button> */}

                {/* <Button   inverted color='yellow'   style={{margin:"auto",  marginLeft:"30px", marginRight:"10px"  ,width: "10vw", height:"6vw",  minWidth: "200px",minHeight:"50px" }} onClick={(e) => this.handleMenuChange(serviceOptions[1].text)} >
                        Attach an Image File
                        </Button> */}
     

           
                 
                          <Grid.Column   width={16} style={{padding: "0px"}}>


                            {/* <div style={{ cursor: 'pointer' }} onClick={(e) => this.handleMenuChange(serviceOptions[0].text)}
                            // onMouseEnter={this.mouseHoverEnter}
                            // onMouseLeave={this.mouseHoverLeave}
                            >




                              <Message icon='user md'
                                header='Healthcare Brief'
                                content='Create a Draft Project'></Message></div> */}

{/* {this.projectStatus()}
                <Button  floated='right' inverted color='yellow'   style={{margin:"auto",  marginLeft:"10px", marginRight:"30px"  ,width: "10vw", height:"6vw",  minWidth: "200px",minHeight:"50px" }} onClick={(e) => this.handleMenuChange(serviceOptions[1].text)} >
                        Attach an Image File
                        </Button>
     

                  <Button   floated='right' inverted color='blue'   
                  style={{
                    margin:"auto",  marginLeft:"10px", marginRight:"30px", width: "10vw",  height:"6vw", minWidth: "200px", minHeight:"50px"
                    }} onClick={(e) => this.handleMenuChange(serviceOptions[0].text)} >
                        Healthcare Brief
                        </Button> */}
      
                
                          </Grid.Column>


                          

                
            

                    

             
                        </Grid>
                      </div>

                      {/* <Divider 
                      style={{
                        background: "transparent",
                        // border: "0px solid transparent",
                        boxShadow: "none",
                        padding: "0em 0em",
                }}
                      /> */}
                      {this.service === serviceOptions[0].text ? (
                        <React.Fragment>
                          <Form style={{marginTop: "30px"}}  onSubmit={e => this.onSubmit(dispatch, auth, e)}>

                          <Message style={{
                            background: "transparent",
                            border: "1px solid transparent",
                            boxShadow: "none",
                            padding: "0em 0em",
                            height: "6vw",
                            // marginLeft: "1.2vw",
                            
                            minHeight: "100px",
                            textAlign: "left"
                          }}>
                          
                          {this.previousButton()}
                            {this.nextButton()}
       
                            </Message>
               
                            <Step1a
                              currentStep={this.state.currentStep}
                              handleChange={this.onChange}
                              // imgUrl={this.state.imgUrl}
                              title={this.state.title}

                              dob={this.state.dob}
                              gender={this.state.gender}
                              mrn={this.state.mrn}
                              name={this.state.name}
                              heading={this.state.heading}
                              description={this.state.description}
                              age = {this.state.age}

                              />

                            
                            <Step2a
                              currentStep={this.state.currentStep}
                              handleChange={this.onChange}
                              filelogid = {this.filesGroupId}
                              cardId = { cardId }
                              oid={this.props.oid}
                              // heading={this.state.heading}
                              email={this.state.email} />

                            <Step3a
                              currentStep={this.state.currentStep}
                              handleChange={this.onChange}
                              text={this.state.text}
                              price={this.state.price}
                              payment={this.state.payment}
                              // voucher={this.state.voucher} 
                              oid={this.props.oid}
                              auth={this.props.auth} filesGroupId={this.filesGroupId}
                              />
                              {/* {this.handleTitle()} */}
                            {/* {this.previousButton()}
                            {this.nextButton()} */}

                          </Form>
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            {this.service === serviceOptions[1].text ? (
                              <React.Fragment>
                                <br></br>

                                {/* <p>Project Draft</p> */}
                                <div>
                                  {/* <h1> Filepod Table</h1> */}
                                  {/* <FileShare props={this.state.files}> </FileShare> */}
                                  {/* <FileShare auth={this.props.auth} filesGroupId={this.filesGroupId} oid={this.state.oid}> </FileShare> */}

                                  {/* <FilesTables></FilesTables> */}


                                </div>
                              </React.Fragment>
                            ) : (
                                <React.Fragment  >
                                  <div style={{ textAlign: "justified" }} >
                                    <br></br>
                                    <br></br>
                                    <Container>

                                    <Header>Directions</Header>
                                    <p>1) Create a Draft Project </p>
                                    <p>2) Fill in Draft Form</p>
                                    <p>3) Add members in your organization for peer review</p>
                                    <p>4) Upload Xray Chest Images</p>


                                    </Container>
         
                                  </div>



                                </React.Fragment>
                              )}
                          </React.Fragment>
                        )}


                      {this.getCurrentGroup()}

                    </Grid.Column>

                    <Grid.Column floated='right' width={5} style={{padding:'0px'}}  >
                        
                      {/* <Tester auth={this.props.auth} filesGroupId={this.filesGroupId}></Tester> */}
                      <FileLogTable  auth={this.props.auth} filesGroupId={this.filesGroupId}    oid={this.props.oid} />

 
                        
                        

          {/* <MetaPanel
                            currentGroup={this.currentGroup}
                            currentUser={MyStore.auth().currentUser}
                            isDM={false}
                            leaders={MyStore.database().ref().child("users")}
                        /> */}
                        {/* {console.log( MyStore.auth().currentUser)}
                        {console.log(MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ"))}
                        {console.log(MyStore.database().ref().child("directMessages").child("-LwLoqhrvooVCR3mC2Rb"))}
                        {console.log()} */}
                 

                    

                
            
                      


                    </Grid.Column>
                  </Grid>
                </Container>


              </React.Fragment>
            );
          }}

        </Consumer>
      </React.Fragment>
    );
  }
}





const serviceOptions = [
  {
    key: '1',
    text: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
    value: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
    image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    size: 'small',
  },
  {
    key: '2',
    text: 'Draft: Project Delivery',
    value: 'Draft: Project Delivery',
    image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    size: 'small',
  },
  {
    key: '3',
    text: 'Select a Service',
    value: 'Draft: Project Delivery',
    image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    size: 'small',
  },
]





// export default ModalExampleCloseIcon


MasterForm.contextType = MyContext;
export default MasterForm;